function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M405.9 98L322 14.1A48 48 0 00288.1 0H84a48.16 48.16 0 00-48 48.1v416a48 48 0 0048 48h288a48 48 0 0048-48V132a48.23 48.23 0 00-14.1-34zm-37.8 30.1H292V52zM84 464.1v-416h160v104a23.94 23.94 0 0024 24h104v288z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M417.1 448.74L4.33 129.72a11.23 11.23 0 01-2-15.75l13.81-17.73a11.22 11.22 0 0115.76-2l412.76 319a11.22 11.22 0 012 15.75l-13.77 17.73a11.23 11.23 0 01-15.76 2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M319.81 366.85H136.18A21.19 21.19 0 01115 345.66V218.54a21.18 21.18 0 0121.18-21.19h183.63A21.19 21.19 0 01341 218.54v127.12a21.19 21.19 0 01-21.19 21.19zM164.43 222.1a24.72 24.72 0 1024.72 24.72 24.72 24.72 0 00-24.72-24.72zm-21.18 116.5h169.5v-49.44l-38.63-38.63a5.29 5.29 0 00-7.49 0l-59.82 59.82-24.51-24.51a5.29 5.29 0 00-7.49 0l-31.56 31.57z"
});

var SvgNoimage = function SvgNoimage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 449 512.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoimage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noimage.4ba39363.svg";
export { ForwardRef as ReactComponent };